import cookieLadyIcon from './cookieLadyIcon.svg';
import classNames from 'classnames';
import Preact, { Component } from 'preact';
import testId from '../../helpers/testId';
import { hasConsentCookie, setConsentCookie } from './consentCookie';

interface State {
  status: 'unknown' | 'previouslyAccepted' | 'justAccepted' | 'notAccepted';
}

class CookieConsent extends Component<{}, State> {
  state: State = {
    status: 'unknown',
  };

  componentDidMount() {
    this.setState({
      status: hasConsentCookie() ? 'previouslyAccepted' : 'notAccepted',
    });
  }

  handleCloseClick = () => {
    setConsentCookie();

    this.setState({ status: 'justAccepted' });
  };

  render() {
    const { status } = this.state;
    if (['unknown', 'previouslyAccepted'].includes(status)) {
      return null;
    }

    return (
      <div
        className={classNames(
          testId('cookie-consent'),
          'jg-chrome-cookie-consent',
          'jg-position-fixed jg-pin-b',
          'jg-bdt jg-bd--very-light-grey jg-shadow-up-md',
          'jg-w-full jg-space-pvsm',
          'jg-background--white jg-text--center',
          'jg-text--medium-regular jg-color--empress',
          'jg-font-weight-light@md',
          'jg-anim-slide-up jg-anim-fade-in',
          {
            'jg-anim-slide-up--active jg-anim-fade-in--active':
              status === 'notAccepted',
          },
        )}
      >
        <div className="container jg-space-phn jg-space-phxs@md">
          <div className="jg-display-table@md jg-w-full">
            <div
              className={classNames(
                'jg-space-phsm jg-text--pull-left',
                'jg-display-table-cell@md jg-w-3/4@md jg-w-5/6@xl',
              )}
            >
              <div className="jg-text--center jg-display-ib@md">
                <div className="jg-chrome-cookie-consent__icon-wrapper">
                  <img
                    src={cookieLadyIcon}
                    className={classNames(
                      'jg-chrome-cookie-consent__icon',
                      'jg-space-mtxs jg-space-mbms',
                      'jg-space-mvn@md jg-space-mrmd@md',
                    )}
                  />
                </div>
              </div>
              <span
                className={classNames(
                  'jg-chrome-cookie-consent__text-wrapper',
                  'jg-display-b jg-space-mbms',
                  'jg-display-ib@md jg-space-mbn@md jg-align--vertical-middle@md',
                )}
              >
                Hello! We use cookies to give you the best possible experience
                on JustGiving. You can{' '}
                <a
                  className="jg-font-weight-light@md"
                  href="https://www.justgiving.com/info/cookies"
                  target="_blank"
                >
                  read more here
                </a>.
              </span>
            </div>
            <div className="jg-space-phsm jg-display-table-cell@md jg-w-1/4@md jg-w-1/6@xl">
              <button
                className={classNames(
                  testId('cookie-consent__dismiss-button'),
                  'jg-btn jg-btn--ghost jg-font-sizes--medium',
                  'jg-align--vertical-middle@md jg-font-weight-light@md',
                )}
                onClick={this.handleCloseClick}
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CookieConsent;
